import { specialAndNotCombinations, specialOrNotCombinations } from "@/Common/helpers/Expressions/syntax";

const simpleWords = [
	"and",
	"or",
	"not",
	"&",
	"|",
	"!",
	"~",
	",",
	"greater-than-or-equals-to",
	"less-than-or-equals-to",
	"greater-than",
	"less-than",
	...specialAndNotCombinations,
	...specialOrNotCombinations,
];

export const KEYWORD_CONTEXT = {
	alone: "alone",
	beforeParens: "before-parens",
	beforeNumber: "before-number",
} as const;

export interface ReservedWord {
	word: string;
	context: (typeof KEYWORD_CONTEXT)[keyof typeof KEYWORD_CONTEXT];
}

const getReservedWords = (): ReservedWord[] => {
	return [
		...simpleWords.map((word) => ({ word, context: KEYWORD_CONTEXT.alone })),
		{ word: ">=", context: KEYWORD_CONTEXT.beforeNumber },
		{ word: "<=", context: KEYWORD_CONTEXT.beforeNumber },
		{ word: ">", context: KEYWORD_CONTEXT.beforeNumber },
		{ word: "<", context: KEYWORD_CONTEXT.beforeNumber },
		{ word: "contains", context: KEYWORD_CONTEXT.beforeParens },
		{ word: "startsWith", context: KEYWORD_CONTEXT.beforeParens },
		{ word: "endsWith", context: KEYWORD_CONTEXT.beforeParens },
	];
};

export { getReservedWords };
